import { Dispatch } from "redux";
import { setSession } from "@redux/actions/session-actions";
import { logOutRequest } from "@requests/axnadmin-core/log-out";

export const logOutReduxRequest = (dispatch: Dispatch) => async () => {
    const { error } = await logOutRequest();
    if (error) {
        console.error(error);
    }
    dispatch(setSession(null));
};